import {
    useEffect,
    useState,
} from 'react';

import api from '../../api/api';

import AdminLayout from './Components/AdminLayout';
import BlogCategoryModal from './Components/BlogCategoryModal';

type BlogCategory = {

    id: number;

    name: string;

    slug: string;

    is_active: boolean;

    display_order: number;

    blogs_count: number;

    created_at: string;

};

export default function AdminBlogCategories() {
    const [
        categories,
        setCategories,
    ] = useState<BlogCategory[]>([]);

    const [
        deletedCategories,
        setDeletedCategories,
    ] = useState<BlogCategory[]>([]);

    const [
        modalOpen,
        setModalOpen,
    ] = useState(false);

    const [
        selectedCategory,
        setSelectedCategory,
    ] = useState<BlogCategory | null>(
        null
    );

    const loadCategories = async () => {
        const response =
            await api.get(
                '/blog-categories'
            );

        setCategories(
            response.data
        );
    };

    const loadDeletedCategories = async () => {
        const response =
            await api.get(
                '/blog-categories/deleted'
            );

        setDeletedCategories(
            response.data
        );
    };

    useEffect(() => {

        loadCategories();

        loadDeletedCategories();

    }, []);

    const handleSave = async (
        data: any
    ) => {
        if (
            selectedCategory
        ) {
            await api.put(
                `/blog-categories/${selectedCategory.id}`,

                data
            );
        } else {
            await api.post(
                '/blog-categories',

                data
            );
        }

        setModalOpen(
            false
        );

        setSelectedCategory(
            null
        );

        await loadCategories();

        await loadDeletedCategories();
    };

    const handleDelete = async (
        category: BlogCategory
    ) => {
        if (
            category.blogs_count > 0
        ) {
            alert(
                'This category is currently in use.'
            );

            return;
        }

        if (
            !window.confirm(
                'Delete this category?'
            )
        ) {
            return;
        }

        await api.delete(
            `/blog-categories/${category.id}`
        );

        await loadCategories();

        await loadDeletedCategories();
    };

    const handleRestore = async (
        id: number
    ) => {
        await api.post(
            `/blog-categories/${id}/restore`
        );

        await loadCategories();

        await loadDeletedCategories();
    };

    const saveOrder = async (
        ordered: BlogCategory[]
    ) => {
        await api.post(
            '/blog-categories/reorder',

            {

                categories:

                    ordered.map(
                        (
                            category,
                            index
                        ) => ({

                            id:
                            category.id,

                            display_order:
                                index + 1,

                        })
                    ),

            }
        );

        loadCategories();
    };

    const moveUp = async (
        index: number
    ) => {
        if (
            index === 0
        ) {
            return;
        }

        const updated =
            [...categories];

        [

            updated[index],

            updated[index - 1],

        ] = [

            updated[index - 1],

            updated[index],

        ];

        await saveOrder(
            updated
        );
    };

    const moveDown = async (
        index: number
    ) => {
        if (
            index ===
            categories.length - 1
        ) {
            return;
        }

        const updated =
            [...categories];

        [

            updated[index],

            updated[index + 1],

        ] = [

            updated[index + 1],

            updated[index],

        ];

        await saveOrder(
            updated
        );
    };

    return (

        <AdminLayout>

            <div className="page-header">

                <h1>

                    Blog Categories

                </h1>

                <button

                    className="action-btn"

                    onClick={() => {

                        setSelectedCategory(
                            null
                        );

                        setModalOpen(
                            true
                        );

                    }}

                >

                    Add Category

                </button>

            </div>

            <table className="users-table">

                <thead>

                <tr>

                    <th>Name</th>

                    <th>Slug</th>

                    <th>Blogs</th>

                    <th>Status</th>

                    <th>Actions</th>

                </tr>

                </thead>

                <tbody>

                {

                    categories.length === 0

                        ?

                        (

                            <tr>

                                <td
                                    colSpan={5}
                                    style={{
                                        textAlign: 'center'
                                    }}
                                >

                                    No blog categories found.

                                </td>

                            </tr>

                        )

                        :

                        (

                            categories.map(
                                (
                                    category,
                                    index
                                ) => (

                                    <tr
                                        key={
                                            category.id
                                        }
                                    >

                                        <td>

                                            {

                                                category.name

                                            }

                                        </td>

                                        <td>

                                            {

                                                category.slug

                                            }

                                        </td>

                                        <td>

                                            {

                                                category.blogs_count

                                            }

                                        </td>

                                        <td>

                                            {

                                                category.is_active

                                                    ?

                                                    'Active'

                                                    :

                                                    'Inactive'

                                            }

                                        </td>

                                        <td>

                                            <div className="actions">

                                                <button

                                                    className="move-btn"

                                                    disabled={
                                                        index === 0
                                                    }

                                                    onClick={() =>
                                                        moveUp(
                                                            index
                                                        )
                                                    }

                                                >

                                                    ↑

                                                </button>

                                                <button

                                                    className="move-btn"

                                                    disabled={
                                                        index ===
                                                        categories.length - 1
                                                    }

                                                    onClick={() =>
                                                        moveDown(
                                                            index
                                                        )
                                                    }

                                                >

                                                    ↓

                                                </button>

                                                <button

                                                    className="edit-btn"

                                                    onClick={() => {

                                                        setSelectedCategory(
                                                            category
                                                        );

                                                        setModalOpen(
                                                            true
                                                        );

                                                    }}

                                                >

                                                    Edit

                                                </button>

                                                <button

                                                    className="delete-btn"

                                                    onClick={() =>
                                                        handleDelete(
                                                            category
                                                        )
                                                    }

                                                >

                                                    Delete

                                                </button>

                                            </div>

                                        </td>

                                    </tr>

                                )
                            )

                        )

                }

                </tbody>

            </table>

            {

                deletedCategories.length > 0 && (

                    <>

                        <h2
                            style={{
                                marginTop: '40px'
                            }}
                        >

                            Deleted Categories

                        </h2>

                        <table className="users-table">

                            <thead>

                            <tr>

                                <th>Name</th>

                                <th>Actions</th>

                            </tr>

                            </thead>

                            <tbody>

                            {

                                deletedCategories.map(
                                    (
                                        category
                                    ) => (

                                        <tr
                                            key={
                                                category.id
                                            }
                                        >

                                            <td>

                                                {

                                                    category.name

                                                }

                                            </td>

                                            <td>

                                                <button

                                                    className="action-btn"

                                                    onClick={() =>
                                                        handleRestore(
                                                            category.id
                                                        )
                                                    }

                                                >

                                                    Restore

                                                </button>

                                            </td>

                                        </tr>

                                    )
                                )

                            }

                            </tbody>

                        </table>

                    </>

                )

            }

            {

                modalOpen && (

                    <BlogCategoryModal

                        category={
                            selectedCategory
                        }

                        onClose={() => {

                            setModalOpen(
                                false
                            );

                            setSelectedCategory(
                                null
                            );

                        }}

                        onSave={
                            handleSave
                        }

                    />

                )

            }

        </AdminLayout>

    );
}
